/**
 * This is a polyfill library that enables IE 11 to run modern websites
 * Do not use Babel as it conflicts with Google Maps API library
 */
// import "core-js/stable";
import 'regenerator-runtime/runtime'
import Vue from 'vue'
import VModal from 'vue-js-modal'
import VueClosable from 'vue-closable'
import VueScrollTo from 'vue-scrollto'
import VueObserveVisibility from 'vue-observe-visibility'
import MultiRangeSlider from 'multi-range-slider-vue'
import 'multi-range-slider-vue/MultiRangeSliderBarOnly.css'
import Dropzone from "dropzone";
import VueEasyLightbox from 'vue-easy-lightbox'
import debounce from 'lodash'

window.Vue = Vue

Vue.component('app-header', () => import('./components/Header'))
Vue.component('app-slideshow-services', () => import('./components/SliderServices'))
Vue.component('app-slideshow-testimonials', () => import('./components/SliderTestimonials'))
Vue.component('app-slideshow-service-gallery', () => import('./components/SliderServiceGallery'))
Vue.component('app-our-people', () => import('./components/OurPeople'))
Vue.component('app-gallery', () => import('./components/GalleryArea'))
Vue.component('listing-gallery', () => import('./components/ListingGallery'))

Vue.component('app-map', () => import('./components/Map'))
Vue.component('app-featured-boats', () => import('./components/FeaturedBoats'))
Vue.component('find-a-boat', () => import('./components/FindABoat'))
Vue.component('app-home-search', () => import('./components/HomeSearch'))
Vue.component('app-slide-show', () => import('./components/SlideShow'))
Vue.component('app-tabs-view', () => import('./components/TabsView'))
Vue.component('app-tabs-view-sticky', () => import('./components/TabsViewSticky'))
Vue.component('app-listings-import', () => import('./components/ListingsImport'))
Vue.component('multi-range-slider', MultiRangeSlider)
Vue.component('multi-select', () => import('./components/MultiSelect'))
Vue.component('career-search', () => import('./components/CareerSearch'))

/*** modals ***/
Vue.component('app-subscribe-modal', () => import('./components/SubscribeModal'))
Vue.component('app-finance-modal', () => import('./components/FinanceModal'))
Vue.component('app-partshin-modal', () => import('./components/PartsHin'))
Vue.component('app-enquire-modal', () => import('./components/EnquireModal'))

/*** FORMS ***/
Vue.component('app-sell-a-boat-form', () => import('./components/SellABoatForm'))
Vue.component('app-file-uploader', () => import('./components/FileUploader'))

Vue.use(VModal)
  .use(VueClosable)
  .use(VueScrollTo)
  .use(VueObserveVisibility)
  .use(VueEasyLightbox)

new Vue({
  data () {
    return {
      isLoaded: false,
      tab: 'east',
      faq: null,
      menu: [
        { url: '/pet-records', title: 'Pet Records' },
        { url: '/medicinal-refill', title: 'Medicinal Re-fill' },
        { url: '/services', title: 'Services' },
        { url: '/blog', title: 'Clinic News' },
        { url: '/contact', title: 'Contact Us' },
        { url: '/shop', title: 'Shop' },
        { url: '/about', title: 'About' },
        { url: '/gallery', title: 'Gallery' },
        { url: '/our-people', title: 'Our People' },
      ],
    }
  },

  mounted() {
    document.onreadystatechange = () => {
      if (document.readyState == 'complete') {
        this.isLoaded = true
      }
    }

    if(['/home', '/home-au', '/'].indexOf(window.location.pathname) != -1 && this.getCookie('has_popup') != 1 && this.getCookie('is_subscribed') != 1) {
      this.delayPopup()
    }
  },

  methods: {

    delayPopup: debounce(async function () {
      this.$modal.show('subs-popup')
      this.setCookie('has_popup', 1, 1);
    }, 120000),

    setCookie(cname, cvalue, exdays) {
      const d = new Date();
      d.setTime(d.getTime() + (exdays*24*60*60*1000));
      let expires = "expires="+ d.toUTCString();
      document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    },

    getCookie(cname) {
      let name = cname + "=";
      let decodedCookie = decodeURIComponent(document.cookie);
      let ca = decodedCookie.split(';');
      for(let i = 0; i <ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == ' ') {
          c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
          return c.substring(name.length, c.length);
        }
      }
      return "";
    },

    toggleTab (tab) {
      this.tab = tab
    },

    toggleFAQ (index) {
      if (index === this.faq) {
        this.faq = null
      } else {
        this.faq = index
      }
    },

    showHinTooltip () {
      this.$modal.show('parts-hin-popup')
    },

    showFinancePopup (amountToFinance, title) {
      // handle case where amountToFinance is sometimes the click event
      if (!['string', 'number'].includes(typeof amountToFinance)) {
        amountToFinance = '0'
      }
      this.$modal.show('finance-popup', { amountToFinance, title })
    },

    showEnquirePopup (title,honeypot) {
      this.$modal.show('enquire-popup', { 'title':title, 'honeypot': honeypot})
    },

    showSubscribePopup () {
      this.$modal.show('subs-popup')
    },
  },
}).$mount('#app')


Dropzone.options.myDropzone= {
  paramName: "file",
  maxFilesize: 1, // MB
  accept: function(file, done) {
    // if (file.name == "justinbieber.jpg") {
    //   done("Naha, you don't.");
    // }
    // else { done(); }
    alert('attached!');
  }
  // autoProcessQueue: false,
  // uploadMultiple: true,
  // parallelUploads: 5,
  // maxFiles: 5,
  // maxFilesize: 1,
  // acceptedFiles: 'image/*',
  // addRemoveLinks: true,
  // init: function() {
  //     dzClosure = this; // Makes sure that 'this' is understood inside the functions below.

  //     // for Dropzone to process the queue (instead of default form behavior):
  //     document.getElementById("submit-all").addEventListener("click", function(e) {
  //         // Make sure that the form isn't actually being sent.
  //         e.preventDefault();
  //         e.stopPropagation();
  //         dzClosure.processQueue();
  //     });

  //     //send all the form data along with the files:
  //     this.on("sendingmultiple", function(data, xhr, formData) {
  //         formData.append("firstname", jQuery("#firstname").val());
  //         formData.append("lastname", jQuery("#lastname").val());
  //     });
  // }
}
